/**
 * card-product-swatch.js
 *
 * Handles color swatch selection on product cards (snippets/card-product.liquid).
 *
 * Root cause fixed: swatch clicks previously did nothing (the wiring script was
 * left inside a Liquid {% comment %} block), so the hidden variant id input kept
 * pointing at the card's default `selected_or_first_available_variant` no matter
 * which swatch the shopper clicked. Clicking "Add to Cart" therefore tried to add
 * whatever variant happened to be unavailable, product-form.js caught the /cart/add
 * error and permanently swapped the button to "Sold Out" (see product-form.js
 * onSubmitHandler, .sold-out-message branch).
 *
 * This listener keeps the hidden variant input, submit button state/label, and
 * swatch image in sync with the swatch the shopper actually selects, using the
 * per-card variant JSON emitted by card-product.liquid
 * (script[data-card-variant-json]).
 *
 * Attached once via event delegation on document since many card-product.liquid
 * instances can render on a single page (collection grids, related products, etc.).
 */
(function () {
  if (window.cardProductSwatchListenerAttached) return;
  window.cardProductSwatchListenerAttached = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.swatch-item');
    if (!swatch) return;

    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    var variantId = swatch.getAttribute('data-variant-id');
    if (!variantId) return;

    // Update selected swatch state
    var swatches = card.querySelectorAll('.swatch-item');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.remove('selected');
    }
    swatch.classList.add('selected');

    // Swap the card image to the selected variant's image, if available
    var image = card.querySelector('.card__media .media img');
    var newImage = swatch.getAttribute('data-image');
    if (image && newImage) {
      image.src = newImage;
      image.removeAttribute('srcset');
    }

    // Look up the selected variant's availability from the embedded JSON
    var variant = null;
    var variantDataEl = card.querySelector('[data-card-variant-json]');
    if (variantDataEl) {
      try {
        var variants = JSON.parse(variantDataEl.textContent);
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].id) === String(variantId)) {
            variant = variants[j];
            break;
          }
        }
      } catch (error) {
        console.error('card-product-swatch: unable to parse variant JSON', error);
      }
    }

    var isAvailable = variant ? !!variant.available : true;

    // Sync every hidden variant id input in this card (product-form + any quick-add form)
    var variantInputs = card.querySelectorAll('input.product-variant-id');
    for (var k = 0; k < variantInputs.length; k++) {
      variantInputs[k].value = variantId;
      variantInputs[k].disabled = !isAvailable;
      variantInputs[k].dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Sync the submit button(s): disabled state, label, and sold-out message
    var submitButtons = card.querySelectorAll('product-form [type="submit"]');
    var strings = window.variantStrings || {};
    var addToCartText = strings.addToCart || 'Add to cart';
    var soldOutText = strings.soldOut || 'Sold out';

    for (var m = 0; m < submitButtons.length; m++) {
      var submitButton = submitButtons[m];

      submitButton.toggleAttribute('disabled', !isAvailable);
      submitButton.removeAttribute('aria-disabled');

      var addLabel = submitButton.querySelector('.add_generally');
      var serviceLabel = submitButton.querySelector('.add_service');
      var soldOutMessage = submitButton.querySelector('.sold-out-message');

      if (soldOutMessage) soldOutMessage.classList.add('hidden');
      if (addLabel) {
        addLabel.classList.remove('hidden');
        addLabel.textContent = isAvailable ? addToCartText : soldOutText;
      }
      if (serviceLabel) {
        serviceLabel.textContent = isAvailable ? 'Personalise' : soldOutText;
      }
    }
  });
})();